const form = {
  formId: "edit-company-form",
  formField: {
    companyName: {
      name: "company_name",
      label: "company name",
      type: "text",
      placeholder: "eg. Micheal",
      errorMsg: "Company name is required.",
    },
    tenantId: {
      name: "tenant_id",
      label: "company id",
      type: "text",
    },
    emailAddress: {
      name: "email_address",
      label: "email address",
      type: "email",
      placeholder: "eg. example@address.com",
      errorMsg: "Email address is required.",
      invalidMsg: "Your email address is invalid",
    },
    confirmEmailAddress: {
      name: "confirmEmailAddress",
      label: "Confirm Email Address",
      type: "email",
      placeholder: "eh. example@address.com",
      errorMsg: "Confirm Email Address is required",
      mismatchErrorMsg: "Doesn't match with the email address provided",
      invalidMsg: "Your confirm email address is invalid",
    },
    phoneNumber: {
      name: "business_phone",
      label: "phone number",
      type: "text",
      placeholder: "+40 941 538 024",
      errorMsg: "Phone number is required",
      invalidMsg: "The phone number you entered is invalid",
    },
    addressLine1: {
      name: "address_line_1",
      label: "address line 1",
      type: "text",
      placeholder: "eg. Bucharest",
      errorMsg: "Address Line 1 is required",
    },
    addressLine2: {
      name: "address_line_2",
      label: "address line 2",
      type: "text",
      placeholder: "eg. Bucharest",
      errorMsg: "Address Line 2 is required",
    },
    country: {
      name: "country",
      label: "country",
      type: "text",
      placeholder: "eg. Bucharest",
      errorMsg: "Country is required",
    },
    county: {
      name: "county",
      label: "county",
      type: "text",
      placeholder: "eg. Bucharest",
      errorMsg: "County is required",
    },
    city: {
      name: "city",
      label: "city",
      type: "text",
      placeholder: "eg. Bucharest",
      errorMsg: "City is required",
    },
    state: {
      name: "state",
      label: "state",
      type: "text",
      placeholder: "eg. Bucharest",
      errorMsg: "State is required",
    },
    zipcode: {
      name: "zip",
      label: "zip code",
      type: "text",
      placeholder: "00000",
      errorMsg: "Zipcode is required",
    },
    region: {
      name: "region",
      label: "region",
      type: "select",
      placeholder: "Select Region",
      errorMsg: "Region is required",
    },
  },
};

export default form;
